<template>
  <div class="container page setbank-page">
    <van-nav-bar :title="$t('setting.bank_info')" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main">
      <div class="add-card" v-if="!is_bind" @click="toBindCard()">
        <van-icon name="plus" />
        <span>{{ $t('setting.add_bank') }}</span>
      </div>

      <template v-else>
        <div class="bank-card">
          <div class="card-top">
            <van-icon name="card" class="card-icon" />
            <span class="bank-name">{{ bankInfo.bankinfo }}</span>
          </div>
          <div class="card-number">{{ maskBankId(bankInfo.bankid) }}</div>
          <div class="card-bottom">
            <div class="cardholder">
              <span class="holder-label">{{ $t('setting.cardholder') }}</span>
              <span class="holder-name">{{ displayName }}</span>
            </div>
            <van-icon name="checked" class="checked-icon" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind: false,
      bankInfo: {},
      userInfo: {}
    }
  },
  computed: {
    displayName() {
      return this.bankInfo.username || this.userInfo.name || '-'
    }
  },
  methods: {
    maskBankId(value) {
      if (!value) return '-'
      const raw = String(value).replace(/\s/g, '')
      if (raw.length <= 8) return raw
      const first = raw.slice(0, 4)
      const last = raw.slice(-4)
      const middleGroupCount = Math.ceil((raw.length - 8) / 4)
      const middle = Array(middleGroupCount).fill('****').join(' ')
      return `${first} ${middle} ${last}`
    },
    back() {
      return window.history.back()
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true
            this.bankInfo = res.data.info || {}
          } else {
            this.is_bind = false
            this.bankInfo = {}
          }
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    toBindCard() {
      this.$router.push({ path: '/BindCard' })
    }
  },
  activated() {
    if (localStorage.getItem('token')) {
      this.getUserBankInfo()
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo()
      this.getUserBankInfo()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

.setbank-page {
  background-color: #f2f2f5;
}

.main {
  padding: 0.75rem;
  box-sizing: border-box;
}

.add-card {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 7.5rem;
  background: #fff;
  border: 0.125rem dashed #ddd;
  border-radius: 0.75rem;
  color: #8056e3;
  font-size: 1rem;
  font-weight: 500;

  .van-icon {
    font-size: 1.25rem;
    margin-right: 0.5rem;
  }
}

.bank-card {
  border-radius: 0.75rem;
  padding: 1.25rem 1rem;
  color: #fff;
  background: linear-gradient(135deg, #8056e3 0%, #c94d9a 55%, #db498c 100%);
  box-sizing: border-box;
}

.card-top {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  .card-icon {
    font-size: 1.375rem;
    margin-right: 0.5rem;
  }

  .bank-name {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.2;
  }
}

.card-number {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 1.25rem;
  letter-spacing: 0.06em;
  word-break: break-all;
}

.card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .cardholder {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
  }

  .holder-label {
    font-size: 0.75rem;
    opacity: 0.85;
  }

  .holder-name {
    font-size: 0.9375rem;
    font-weight: 600;
    line-height: 1.3;
    word-break: break-all;
  }

  .checked-icon {
    font-size: 1.375rem;
    flex-shrink: 0;
    margin-left: 0.5rem;
  }
}
</style>
